/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps } from 'framework/ui/field';
import { ASSET_CATEGORIES_OPTIONS } from 'domain/finance/assets/useAssetService';

const AssetCategoryField = (props: FieldProps) => {
  return <EnumField options={ASSET_CATEGORIES_OPTIONS} {...props} />;
};

export default AssetCategoryField;
